import { render, staticRenderFns } from "./BlogsComponent.vue?vue&type=template&id=29d5fdeb&scoped=true"
import script from "./BlogsComponent.vue?vue&type=script&lang=js"
export * from "./BlogsComponent.vue?vue&type=script&lang=js"
import style0 from "./BlogsComponent.vue?vue&type=style&index=0&id=29d5fdeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d5fdeb",
  null
  
)

export default component.exports